const nodeListToArray = (nodeList) => {
  if (!nodeList) {
    return []
  }

  return [].slice.call(nodeList)
}

const uniqueArray = (array = []) => {
  return array.filter((item, i, a) => a.indexOf(item) === i)
}

export { nodeListToArray, uniqueArray }
